import KindOfLearning from '~/pages/anatomy/kindOfLearning/libs/components/KindOfLearning'
import { TPageProps } from '~/shared/types/commonTypes'

const KindOfLearningAnatomy = ({ nextPagePath, pageId }: TPageProps) => (
  <KindOfLearning nextPagePath={nextPagePath} pageId={pageId} />
)

export default KindOfLearningAnatomy
